<app-form-input 
    [parentForm]="parentForm"
    [disabled]="disabled"
    [value]="typeAdresseComplete?.personneMorale" 
    [label]="step12.getpersonnemorale"
    [type]="'text'" 
    [rule]="'minSize_3|maxSize_1000'"
    [errorMessage]="{'minLength' : 'ctr_36'}"
    [name]="getUid()+'_SepAtt_personneMorale'">
</app-form-input>

<app-type-pers  
    [uid]="getUid()" 
    [parentForm]="parentForm"
    [disabled]="disabled"
    [personnePhysique]="typeAdresseComplete?.personnePhysique">
</app-type-pers>

<app-type-adresse  
    [uid]="getUid()" 
    [parentForm]="parentForm"
    [disabled]="disabled"
    [filtreRG]="filtreRG"
    [nbIteration]="nbIteration"
    [adr]="typeAdresseComplete?.adr">
</app-type-adresse>

<app-type-coord  
    [uid]="getUid()" 
    [parentForm]="parentForm"
    [disabled]="disabled"
    [coord]="typeAdresseComplete?.coord">
</app-type-coord>

